module.exports = __webpack_public_path__ + "static/media/reachedTournamentTop10_50_75.cf6e681d.png";